var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 612 792",
    style: {
      enableBackground: "new 0 0 612 792"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 277.97,
    y: 396.1,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 711.4044 84.2562)",
    className: "st0",
    width: 71.21,
    height: 3.47
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.43,
    y: 396.1,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 835.8608 -40.2002)",
    className: "st0",
    width: 71.21,
    height: 3.47
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.54,
    y: 339.97,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 754.2856 683.4133)",
    className: "st0",
    width: 71.21,
    height: 3.47
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.46,
    y: 462.08,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 492.1377 927.6237)",
    className: "st0",
    width: 71.21,
    height: 3.47
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.54,
    y: 462.08,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 754.2856 927.6237)",
    className: "st0",
    width: 71.21,
    height: 3.47
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 438.03,
    cy: 238.29,
    r: 36.98
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 438.03,
    cy: 341.71,
    r: 36.98
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 438.03,
    cy: 465.55,
    r: 36.98
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 314.19,
    cy: 465.55,
    r: 36.98
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 314.19,
    cy: 341.71,
    r: 36.98
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 191.31,
    cy: 341.71,
    r: 36.98
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 191.31,
    cy: 465.55,
    r: 36.98
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 314.19,
    cy: 569.37,
    r: 36.98
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0f79cf418c4288acf885c38c5b43738a.svg";
export { ForwardRef as ReactComponent };